import { render } from "./UserGroupForm.vue?vue&type=template&id=65e30401&scoped=true"
import script from "./UserGroupForm.vue?vue&type=script&lang=ts"
export * from "./UserGroupForm.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-65e30401"

export default script